import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const TenantConcept = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 50 26"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...rest}
    >
      <path d="M25 7 10.465 26H0L14.535 7H25zm25-7L35.227 19H25L39.773 0H50z" fillRule="evenodd" />
    </svg>
  );
};

TenantConcept.displayName = 'TenantConcept';
